var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveBookingLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61006 1.95553V0.500977H5.81006V1.95553H12.0039V0.500977H13.2039V1.95553H14.0645C15.6712 1.95553 16.9736 3.25797 16.9736 4.86462V13.5919C16.9736 15.1985 15.6712 16.501 14.0645 16.501H3.88272C2.27608 16.501 0.973633 15.1985 0.973633 13.5919V4.86462C0.973633 3.25797 2.27608 1.95553 3.88272 1.95553H4.61006ZM4.61006 3.04644H3.88272C2.87857 3.04644 2.06454 3.86046 2.06454 4.86462V6.68279H15.8827V4.86462C15.8827 3.86047 15.0687 3.04644 14.0645 3.04644H13.2039V4.86461H12.0039V3.04644H5.81006V4.86461H4.61006V3.04644ZM15.8827 13.5919V7.7737H2.06454V13.5919C2.06454 14.596 2.87857 15.4101 3.88272 15.4101H14.0645C15.0687 15.4101 15.8827 14.596 15.8827 13.5919Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveBookingLogo);
export default __webpack_public_path__ + "static/media/activeBookingLogo.5d8d46e1098a7bd3a5c86b2fc811eb87.svg";
export { ForwardRef as ReactComponent };